import { useQuery } from '@tanstack/react-query';

import { simulationsEndpoints as endpoints } from '@/api/endpoints';
import { callGet } from '@/api/fetcher';
import type { SchedulesListResponse } from '@/modules/simulations/types';

export const SchedulesAPI = Object.freeze({
  listSchedules: async (brainId: string): Promise<SchedulesListResponse> =>
    callGet(endpoints.schedules(brainId)),
});

const useSchedules = (brainId?: string) => {
  const { data: schedulesData, isLoading } = useQuery<SchedulesListResponse>({
    queryKey: [endpoints.schedules(brainId!)],
    queryFn: () => SchedulesAPI.listSchedules(brainId!),
    enabled: !!brainId,
  });

  return { schedules: schedulesData?.simulation_schedules, isLoading };
};

export default useSchedules;
